// İSG Portal — SideNav (S33 planı Stage 2/3: metin-yalnız, İKON YOK, katlanmaz). Aktiflik
// `react-router-dom`'un `NavLink`'i ile (gerçek gezinme + otomatik `aria-current="page"`).
// NOT (Slice 2 bulgusu): `NavLink`'in `isActive`'i yalnız `pathname` karşılaştırır, `search`'e
// HİÇ bakmaz (react-router@7) — aynı `to` gövdesini (`/permits`) paylaşan, yalnız `?status=`
// farkıyla ayrılan birden çok satır HEPSİ birden aktif görünür.
//
// **`matchSearch` (S33 Slice 4 QA fix, OWNER DECISION — `S33-4-list-pages-qa.md`'nin QA-fix
// talimatı §5).** Yukarıdaki sınırlamanın KENDİSİ burada çözülür: bir öğeye `matchSearch`
// verilirse aktiflik `pathname` EŞLEŞMESİ (NavLink'in kendi `isActive`'i) VE `matchSearch`'ün
// KENDİSİ `true` dönerse sayılır — üç kardeşin (Bekleyen onay/Aktif/Tümü) AYNI `to` gövdesini
// (`/permits`) paylaşıp yalnız `?status=` ile ayrılması TEK satır aktif gösterir.
//
// **Grup başlığı TIKLANAMAZ.** `children` dolu bir üst öğe KENDİ `to`'suna giden bir `NavLink`
// DEĞİL, düz bir etiket (`GroupLabel`) — üç alt öğeden biri zaten "Tümü" (filtresiz) anlamına
// geldiğinden üst satırın AYRICA tıklanabilir olması ya gereksiz bir yinelenen rota olurdu ya da
// ÇİFT vurgu üretirdi. Grup, alt öğelerinden biri aktifken vurgulanır, ayrı bir katlama durumu
// YOKTUR (alt öğeler expanded modda HER ZAMAN görünür).
//
// **`search` alanı.** `matchSearch` yalnız VURGUYU çözer; TIKLAMANIN KENDİSİ `to`'ya gider.
// `to` SALT pathname kalır (`itemMatchesLocation`'ın karşılaştırması bunu ister); `search`
// verilirse `NavLink`'e `{ pathname: to, search }` nesnesi olarak geçirilir.
//
// **S34-3 eklemeleri (design review `S34-carbon-phase2-plan.md` §3, M5/M6/M9) — ÜÇÜ de
// ADDİTİF, `web-supplier` (bu primitifin başka hiçbir tüketicisi yok) ETKİLENMEZ:**
//   - `icon?: LucideIcon` — satırın solunda 16px ikon (`currentColor`, satırın kendi
//     `text-muted`/`text-fg` durumunu miras alır — ayrı bir renk sınıfı GEREKMEZ).
//   - `section?: string` — ardışık öğeleri bir bölüm başlığı altında gruplar (üstteki
//     "Operasyon/Uyum/Sistem" gibi). SideNav öğeleri YENİDEN SIRALAMAZ — ardışık aynı `section`
//     değeri taşıyan öğeler TEK bir koşuya (run) toplanır; gruplama sorumluluğu çağıranındır.
//     Bu, `AppLayout`'un bugüne dek İKİ ayrı `<SideNav>` (+ aralarında elle bir ayraç) render
//     etmesinin yerine TEK bir `<nav>` (Carbon left panel deseni, review §3 "replaces today's
//     two navs and their divider") koyar; her bölüm kendi `<ul aria-labelledby>`'sidir.
//   - `collapsed` (rail modu, 48px, review M5 "no flyout") — `children` dolu bir öğe TEK bir
//     linke ÇÖKER (`RailGroupRow`, `item.to`'ya gider, aktiflik = herhangi bir çocuk aktif);
//     çocuklar rail'de HİÇ render EDİLMEZ (flyout YOK — 3 link zaten `/permits`'in kendi durum
//     filtresiyle karşılanıyor, review M5). Her satırın erişilebilir adı DOM'da `sr-only`
//     kalır (tooltip'in açılmasına BAĞIMLI DEĞİLDİR, review §3 "the name never depends on the
//     tooltip") — görünür/gizli metnin KENDİSİ `Tooltip`'in `asChild` moduna (M5) sarılır, o da
//     Radix'in hover/focus AÇMASINI aynen kullanır (bkz. `Tooltip.tsx`'in dosya başlığı).
//     `railLabel?: string` — yalnız GRUP öğeleri için: rail'deki tek linkin tooltip/`sr-only`
//     metnini (ör. "Çalışma İzinleri: 5 izin onay bekliyor") ÇAĞIRAN besler; bu primitif hangi
//     çocuğun sayısının "aciliyet" taşıdığını ya da metnin dilini BİLMEZ (aynı desen: `Tag`'in
//     hazard işaretçisi `icon` slotundan gelir, `Tag` hazard'ı hiç bilmez). Verilmezse `label`e
//     düşülür. Rail'de bir "bekleyen" NOKTASI (6px, `bg-primary`) yalnız GÖRSEL bir ipucu —
//     sayının TEK taşıyıcısı asla o nokta değildir (tooltip + `sr-only` ad zaten sayıyı taşır).
//   - Toggle (`onToggleCollapsed`) — `<nav>`'ın KENDİ son satırı, ayrı bir `border-t` ile
//     (öğe listesinin sarmalayıcısı `flex-1` taşıdığından toggle KENDİLİĞİNDEN dibe iner, ayrı
//     bir `mt-auto` GEREKMEZ), review §3 "stays in the same place in both states, so focus
//     stays on it after toggling" — aynı DOM düğümü collapse/expand arasında REMOUNT OLMAZ.
//     Yalnız `onToggleCollapsed` verilirse render edilir (Storybook demoları toggle'sız kalabilir).
//
// **`matchPrefixes` (owner review B2 item 7, 2026-09-28).** `itemMatchesLocation` yukarıdaki
// `matchSearch` dışında artık İKİNCİ bir esnetme kabul eder: bir öğeye (ya da `children` taşıyan
// bir GRUP öğesine) `matchPrefixes` verilirse, `pathname` tam `to`ya eşit OLMASA bile bu
// öneklerden birinin ALTINDAYSA (`pathname === prefix || pathname.startsWith(prefix + '/')`) öğe
// yine aktif sayılır. Kök neden: `NavLink`in `end` semantiği (ve bu dosyanın kendi `to`
// eşleşmesi) yalnız TAM pathname'i sayar — bir sekme kabuğunun (İş İzni Tipleri'nin dört
// sekmesi, Ayarlar'ın Şube/Saha'sı, Yönetim'in tüm sekmeleri) ya da bir detay sayfasının
// (`/contractors/{uuid}` gibi) sahibi menü öğesi, kullanıcı o ALT SAYFAYA geçtiği anda
// vurgusunu KAYBEDİYORDU — `to` sabit kalırken URL değişiyor. `matchPrefixes` bu ALT AĞACI
// açıkça adlandırır (çağıran hangi öneklerin "aynı bölüm" sayıldığını bilir, bu bileşen route
// ağacını BİLMEZ); `to`nun KENDİSİ zaten örtük bir önek olarak sayılmaz — istenen her kök AYRICA
// listelenir (bugünkü tüketicilerin hepsi `to`yu da listeye ekler, açıklık için). **`matchSearch`
// taşıyan çocuklar (İş İzni Tipleri'nin Bekleyen onay/Aktif/Tümü'sü) BUNDAN ETKİLENMEZ** — onlar
// zaten kendi `matchSearch`leriyle TAM `pathname` eşleşmesi ister (owner kararı: "keep the Work
// permits ?status children exact"); `matchPrefixes` yalnız GRUBUN KENDİSİNE (üst öğeye,
// `GroupLabel`in "self" kontrolüne) ya da ÇOCUKSUZ bir `Row`a eklenir, çocuklara DEĞİL.

import type { LucideIcon } from 'lucide-react';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { useId } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Tooltip } from './Tooltip';
import { cn } from './cn';

export interface SideNavItem {
  label: string;
  /** SALT pathname — `itemMatchesLocation`/`GroupLabel` bunu `location.pathname` ile
   * DOĞRUDAN karşılaştırır, bir sorgu dizesi TAŞIMAMALI (dosya başlığı notu). */
  to: string;
  /** Gezinme hedefinin sorgu kısmı (ör. `?status=Submitted`) — verilirse `NavLink`'e
   * `{ pathname: to, search }` olarak geçirilir; TIKLAMA gerçekten bu sorguya gider (dosya
   * başlığı notu). */
  search?: string;
  /** Sağa hizalı, sessiz sayaç (ör. bekleyen onay sayısı). Expanded modda görünür; rail'de bir
   * GRUP öğesinin çocuklarından biri >0 sayı taşıyorsa o grubun rail satırında bir nokta
   * doğurur (dosya başlığı notu). */
  count?: number;
  /** Alt öğeler — expanded modda HER ZAMAN görünür (katlanmaz). Doluysa üst öğe expanded'da
   * TIKLANAMAZ bir grup başlığına döner, rail'de TEK bir linke çöker (dosya başlığı notu). */
  children?: SideNavItem[];
  /**
   * `pathname` eşleşmesine EK bir koşul — aynı `to`'yu paylaşan kardeşleri `?search`'e göre
   * ayırt eder (dosya başlığı notu). Verilmezse yalnız `pathname` (NavLink'in kendi
   * `isActive`'i) yeterlidir.
   */
  matchSearch?: (search: URLSearchParams) => boolean;
  /** S34-3 — satırın solundaki 16px ikon (dosya başlığı notu). */
  icon?: LucideIcon;
  /** S34-3 — ardışık öğeleri bir bölüm başlığı altında gruplar (dosya başlığı notu). */
  section?: string;
  /** S34-3, yalnız `children` dolu öğeler — rail modunda tek linkin tooltip/`sr-only` metni;
   * verilmezse `label`e düşülür (dosya başlığı notu). */
  railLabel?: string;
  /** Owner review B2 item 7 — bu öğenin (ya da grup öğesiyse GRUBUN kendisinin) aktif sayılacağı
   * EK pathname önekleri; `to`ya TAM eşitlik dışında bu öneklerin altındaki her alt sayfa da
   * vurguyu taşır (dosya başlığı notu). `matchSearch` taşıyan ÇOCUKLARA eklenmez (dosya başlığı
   * notu — "keep the Work permits ?status children exact"). */
  matchPrefixes?: string[];
}

const rowBase =
  'flex h-8 items-center justify-between gap-2 px-4 text-sm text-muted transition-colors ' +
  'hover:bg-surface-hover hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset';

const rowActive =
  'bg-surface-muted font-semibold text-fg shadow-[inset_4px_0_0_var(--color-primary)]';

const railRowBase =
  'relative flex h-8 w-full items-center justify-center rounded-md text-muted transition-colors ' +
  'hover:bg-surface-hover hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset';

/** Bir öğenin GERÇEKTEN aktif olup olmadığı — `pathname` (NavLink'in `end` semantiğiyle aynı,
 * tam eşleşme) VE varsa `matchSearch`. Grup başlığının "alt öğelerimden biri aktif mi" sorusunu
 * yanıtlamak için de kullanılır (aşağıda). */
function itemMatchesLocation(item: SideNavItem, pathname: string, search: URLSearchParams) {
  if (pathname === item.to) {
    return item.matchSearch ? item.matchSearch(search) : true;
  }
  // `matchPrefixes` (dosya başlığı notu) — TAM `to` eşleşmesi yoksa, bir alt-ağaç öneki altında
  // mı diye bakılır. `matchSearch` burada KASITLI OLARAK göz ardı edilir: alt sayfalar (detay,
  // diğer sekmeler) `to`nun kendi sorgu anlamını TAŞIMAZ.
  return (item.matchPrefixes ?? []).some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

function Row({ item, indent = false }: { item: SideNavItem; indent?: boolean }) {
  const location = useLocation();
  // `aria-current` — NavLink kendi varsayılanını yalnız `pathname`den (`isActive`, `end` ile TAM
  // eşleşme) türetir; `matchSearch`i de `matchPrefixes`i de BİLMEZ. İKİSİNDEN biri varsa BİRLEŞİK
  // eşleşmeden (`active`, aşağıda) AÇIKÇA verilir — `undefined` YETMEZ (react-router
  // `"aria-current": ariaCurrentProp = "page"` diye DESTRUCTURE eder, `undefined` varsayılanı
  // TETİKLER); pasifken GEÇERLİ bir ARIA değeri olan `false` şart. İKİSİ de YOKSA `undefined` =
  // NavLink'in kendi varsayılanı DEĞİŞMEZ (dosya başlığı notu, `matchPrefixes`).
  const active = itemMatchesLocation(item, location.pathname, new URLSearchParams(location.search));
  const usesCustomActive = Boolean(item.matchSearch || item.matchPrefixes);
  const Icon = item.icon;
  return (
    <NavLink
      to={{ pathname: item.to, search: item.search }}
      end
      title={item.label}
      aria-current={usesCustomActive ? (active ? 'page' : false) : undefined}
      className={cn(rowBase, indent && 'pl-11', active && rowActive)}
    >
      <span className="flex min-w-0 items-center gap-3">
        {Icon ? <Icon className="h-4 w-4 shrink-0" aria-hidden="true" /> : null}
        <span className="truncate">{item.label}</span>
      </span>
      {item.count != null ? (
        // Sayı ile etiket arasında GERÇEK bir boşluk metin düğümü — erişilebilir ad (linkin
        // TÜM metin içeriği) "Çalışma İzinleri5" gibi bitişik OKUNMASIN diye, iç içe span'lere
        // rağmen (accessible-name algoritması iç içelik değil metin düğümü sırasına bakar).
        <>
          {' '}
          <span className="tnum shrink-0 text-xs text-muted">{item.count}</span>
        </>
      ) : null}
    </NavLink>
  );
}

/** Grup başlığı (expanded) — tıklanamaz (dosya başlığı notu). Herhangi bir alt öğe aktifse
 * metin de vurgulanır (`text-fg font-semibold`), aksi hâlde sessiz (`text-muted`) — arka
 * plan/kenarlık vurgusu (`rowActive`) YOKTUR, o yalnız GERÇEKTEN seçili bir satırın işareti.
 * `matchPrefixes` (dosya başlığı notu) — GRUBUN KENDİSİNDE tanımlıysa (ör. "Çalışma İzinleri"nin
 * `/permits/{uuid}` detay alt-ağacı) çocuklardan HİÇBİRİ eşleşmese de grup yine vurgulanır;
 * çocukların KENDİ `matchSearch`i (Bekleyen onay/Aktif/Tümü) bundan ETKİLENMEZ. */
function GroupLabel({ item }: { item: SideNavItem }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const active =
    (item.children ?? []).some((child) =>
      itemMatchesLocation(child, location.pathname, searchParams),
    ) || itemMatchesLocation(item, location.pathname, searchParams);
  const Icon = item.icon;
  return (
    <div
      className={cn(
        'flex h-8 items-center gap-3 px-4 text-sm',
        active ? 'font-semibold text-fg' : 'text-muted',
      )}
    >
      {Icon ? <Icon className="h-4 w-4 shrink-0" aria-hidden="true" /> : null}
      <span className="truncate">{item.label}</span>
    </div>
  );
}

/** S34-3 rail satırı — çocuksuz öğeler. Erişilebilir ad DOM'da `sr-only` (tooltip'e bağımlı
 * değil, dosya başlığı notu); `Tooltip`'in `asChild` modu Radix'in hover/focus davranışını
 * aynen kullanır (link tıklaması BASTIRILMAZ).
 *
 * **`className` STRING olmak ZORUNDA (design review M1).** `Tooltip asChild` Radix `Slot`
 * üzerinden `NavLink`i sarar; `Slot` `className`i `[slotProp, childProp].filter(Boolean).join(' ')`
 * ile BİRLEŞTİRİR (`@radix-ui/react-slot`). `NavLink`in `className` prop'u FONKSİYON verilirse
 * (`({isActive}) => ...`) bu birleştirme fonksiyonu KENDİ KAYNAK METNİNE çevirir — satır hiçbir
 * gerçek sınıf ALMAZ. Bu yüzden aktiflik burada `Row`daki AYNI `itemMatchesLocation` ile ÖNCEDEN
 * hesaplanır (search/matchSearch semantiği dahil) ve `NavLink`e düz bir STRING geçirilir. */
function RailRow({ item }: { item: SideNavItem }) {
  const location = useLocation();
  const active = itemMatchesLocation(item, location.pathname, new URLSearchParams(location.search));
  const Icon = item.icon;
  const accessibleLabel = item.railLabel ?? item.label;
  return (
    <Tooltip asChild side="right" content={accessibleLabel}>
      <NavLink
        to={{ pathname: item.to, search: item.search }}
        end
        className={cn(railRowBase, active && rowActive)}
      >
        {Icon ? <Icon className="h-4 w-4" aria-hidden="true" /> : null}
        <span className="sr-only">{accessibleLabel}</span>
      </NavLink>
    </Tooltip>
  );
}

/** S34-3 rail satırı — `children` dolu bir öğenin TEK linke çöktüğü hâli (flyout YOK, review
 * M5). `item.to`'ya gider; aktiflik herhangi bir çocuğun `pathname`'i eşleşiyorsa (NavLink'in
 * kendi `end` karşılaştırması burada zaten yeterli — rail'de tek link olduğundan `matchSearch`
 * belirsizliği YOK, üç kardeş tek satıra indirgendi). Bekleyen nokta yalnız GÖRSEL ipucu; sayının
 * TEK taşıyıcısı DEĞİL (dosya başlığı notu). */
function RailGroupRow({ item }: { item: SideNavItem }) {
  const location = useLocation();
  // Bkz. `RailRow`daki not — `className` burada da STRING olmak ZORUNDA (design review M1).
  const active = itemMatchesLocation(item, location.pathname, new URLSearchParams(location.search));
  const Icon = item.icon;
  const accessibleLabel = item.railLabel ?? item.label;
  const hasPending = (item.children ?? []).some((child) => (child.count ?? 0) > 0);
  return (
    <Tooltip asChild side="right" content={accessibleLabel}>
      <NavLink
        to={{ pathname: item.to, search: item.search }}
        end
        className={cn(railRowBase, active && rowActive)}
      >
        {Icon ? <Icon className="h-4 w-4" aria-hidden="true" /> : null}
        {hasPending ? (
          <span
            aria-hidden="true"
            className="absolute right-2.5 top-1.5 h-1.5 w-1.5 rounded-full bg-primary"
          />
        ) : null}
        <span className="sr-only">{accessibleLabel}</span>
      </NavLink>
    </Tooltip>
  );
}

export interface SideNavProps {
  items: SideNavItem[];
  ariaLabel: string;
  /** S34-3 — rail modu (48px, icon-only, tooltip, flyout yok). Verilmezse `false`: bileşen
   * S33'teki gibi tam-genişlik render eder (dosya başlığı notu, additif). */
  collapsed?: boolean;
  /** Verilirse `<nav>`'ın son (asla kaymayan) satırı olarak bir toggle düğmesi render edilir
   * (dosya başlığı notu). Verilmezse hiç render edilmez. */
  onToggleCollapsed?: () => void;
  /** Toggle'ın erişilebilir adı, expanded durumda (ör. "Menüyü daralt"). `onToggleCollapsed`
   * verilirse ZORUNLU (tip bunu zorlamaz, çağıranın sözleşmesidir — `TableToolbar`'ın
   * `densityLabel`iyle aynı desen). */
  collapseLabel?: string;
  /** Toggle'ın erişilebilir adı, rail durumda (ör. "Menüyü genişlet"). */
  expandLabel?: string;
  className?: string;
}

export function SideNav({
  items,
  ariaLabel,
  collapsed = false,
  onToggleCollapsed,
  collapseLabel,
  expandLabel,
  className,
}: SideNavProps) {
  const baseId = useId();

  // Ardışık aynı `section` değerini TEK bir koşuya (run) toplar — SideNav öğeleri YENİDEN
  // SIRALAMAZ (dosya başlığı notu). `section` yoksa (ör. Storybook'un eski demoları) tek,
  // etiketsiz bir bölüm doğar — S33 davranışıyla görsel olarak AYNI.
  const sections: { label?: string; items: SideNavItem[] }[] = [];
  for (const item of items) {
    const current = sections[sections.length - 1];
    if (current && current.label === item.section) {
      current.items.push(item);
    } else {
      sections.push({ label: item.section, items: [item] });
    }
  }

  return (
    <nav id={baseId} aria-label={ariaLabel} className={cn('flex h-full flex-col', className)}>
      <div className="flex-1 overflow-y-auto py-2">
        {sections.map((section, index) => {
          const sectionHeadingId = `${baseId}-section-${index}`;
          // Kararlı anahtar: bölümün İLK öğesinin `to`su (her öğe zaten kendi `<li>`sinde `to +
          // label` ile benzersiz tutuluyor, dosya başlığındaki desenle AYNI) — index DEĞİL.
          const sectionKey = section.items[0]
            ? section.items[0].to + section.items[0].label
            : index;
          return (
            <div key={sectionKey}>
              {section.label ? (
                collapsed ? (
                  // Rail'de bölüm etiketine yer YOK — 1px bir ayraç onun yerini alır (ilk bölüm
                  // hariç, dosya başlığı notu / review §3 "1px divider replaces the section
                  // label").
                  index > 0 ? (
                    <div aria-hidden="true" className="mx-3 my-2 h-px bg-border" />
                  ) : null
                ) : (
                  <div
                    id={sectionHeadingId}
                    className={cn(
                      'px-4 pb-1 text-xs font-semibold tracking-[.32px] text-muted',
                      index === 0 ? 'pt-2' : 'pt-4',
                    )}
                  >
                    {section.label}
                  </div>
                )
              ) : null}
              <ul
                className="flex flex-col gap-0.5"
                aria-labelledby={section.label && !collapsed ? sectionHeadingId : undefined}
              >
                {section.items.map((item) => {
                  const hasChildren = (item.children?.length ?? 0) > 0;
                  return (
                    <li key={item.to + item.label}>
                      {collapsed ? (
                        hasChildren ? (
                          <RailGroupRow item={item} />
                        ) : (
                          <RailRow item={item} />
                        )
                      ) : hasChildren ? (
                        <>
                          <GroupLabel item={item} />
                          <ul className="flex flex-col gap-0.5">
                            {item.children?.map((child) => (
                              <li key={child.to + child.label}>
                                <Row item={child} indent />
                              </li>
                            ))}
                          </ul>
                        </>
                      ) : (
                        <Row item={item} />
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
      {onToggleCollapsed ? (
        <button
          type="button"
          aria-expanded={!collapsed}
          aria-controls={baseId}
          onClick={onToggleCollapsed}
          className={cn(
            'flex h-12 shrink-0 items-center gap-3 border-t border-border px-4 text-sm text-muted transition-colors',
            'hover:bg-surface-hover hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset',
            collapsed && 'justify-center px-0',
          )}
        >
          {collapsed ? (
            <PanelLeftOpen className="h-4 w-4 shrink-0" aria-hidden="true" />
          ) : (
            <PanelLeftClose className="h-4 w-4 shrink-0" aria-hidden="true" />
          )}
          <span className={collapsed ? 'sr-only' : 'truncate'}>
            {collapsed ? expandLabel : collapseLabel}
          </span>
        </button>
      ) : null}
    </nav>
  );
}
